import { Suspense, type ReactElement } from 'react';
import { Box, Spinner } from '@ff-it/ui';
import { EntityFormActions, useEntity } from 'components';
import { LinkedCampaigns } from './LinkedCampaigns';
import { Invoice } from 'modules/invoicing/types';
import { ConsumedLinks } from 'modules/applicator/ConsumedLinks';
import { credit } from 'modules/invoicing/income/actions';
import { isLinkable } from 'modules/linker/isLinkable';
import ImportedBlocks from './ImportedBlocks';

export function Sidebar(): ReactElement | null {
  const context = useEntity<Invoice>();
  const { item, endpoint } = context;
  if (item.state === 'CANCELED') {
    return null;
  }
  const linkabke = isLinkable(item);

  return (
    <Box data-testid="sidebar" display="flex" pl="3" alignItems="flex-start" flexDirection="column" width="1/3">
      <Suspense
        fallback={
          <Box py="8" mx="auto">
            <Spinner color="primary" />
          </Box>
        }
      >
        {linkabke && <LinkedCampaigns endpoint={endpoint} bound={item.sums.link_applied} />}
        {item.direction === 'expense' && <ImportedBlocks expense={item} />}
        {/* @TODO reverse applicalbe or move server side */}
        {item.type === 'INVOICE' && (
          <ConsumedLinks
            type="credit"
            endpoint={endpoint}
            title={
              <Box display="flex" alignItems="center">
                Applied credit notes
                {item.direction === 'income' && (
                  <Box ml="auto" my="-2">
                    <EntityFormActions actions={[credit]} />
                  </Box>
                )}
              </Box>
            }
          />
        )}
        {item.type === 'INVOICE' && item.direction === 'income' && (
          <ConsumedLinks type="advance" endpoint={endpoint} title="Applied advances" />
        )}
        {item.type === 'INVOICE' && item.direction === 'income' && (
          <ConsumedLinks type="compensation" endpoint={endpoint} title="Compensated invoices" />
        )}
      </Suspense>
    </Box>
  );
}
